// extracted by mini-css-extract-plugin
module.exports =  {"sso-buttons":"SSOBar-_PoO__sso-buttons"};